import { AxiosError } from 'axios';

export const isPurchaseLimitError = (error: unknown) => {
  if (!(error instanceof AxiosError)) {
    return false;
  }

  if (!error.response?.data) {
    return false;
  }

  return (
    'errors' in error.response.data &&
    Array.isArray(error.response.data.errors) &&
    error.response.data.errors.some((singleErr: Record<string, unknown>) => singleErr.errorCode === 3059)
  );
};
